/**
 * @generated SignedSource<<e8ea0db403525b0cffa9d95fb86e6e80>>
 * @relayHash 664837e590e5978f849b8a0e2bce8637
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 664837e590e5978f849b8a0e2bce8637

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type useTreatmentPlanForPreventionProgramsQuery$variables = {
  id: string;
};
export type useTreatmentPlanForPreventionProgramsQuery$data = {
  readonly treatmentPlanTemplateById: {
    readonly id: string;
    readonly isDraft: boolean;
    readonly languages: ReadonlyArray<{
      readonly followUpInstructions: string | null;
      readonly language: Language;
      readonly recommendedTreatment: string | null;
      readonly title: string;
    }>;
  } | null;
};
export type useTreatmentPlanForPreventionProgramsQuery = {
  response: useTreatmentPlanForPreventionProgramsQuery$data;
  variables: useTreatmentPlanForPreventionProgramsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TreatmentPlanTemplate",
    "kind": "LinkedField",
    "name": "treatmentPlanTemplateById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDraft",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TreatmentPlanTemplateLanguage",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendedTreatment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followUpInstructions",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTreatmentPlanForPreventionProgramsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useTreatmentPlanForPreventionProgramsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "664837e590e5978f849b8a0e2bce8637",
    "metadata": {},
    "name": "useTreatmentPlanForPreventionProgramsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "38d9a1a482931fecda17b3158070e650";

export default node;
